import { DiscountTypeEnum, PersonTypeEnum } from "../../../shared/utils/enum/enum";
import { StepByStepBudgetingContract } from "./steps";

export enum StutusBudgetEnum {
    GENERATED = 'generated',
    APPROVED = 'approved',
    REJECTED = 'rejected',
    CANCELED = 'canceled',
    EXPIRED = 'expired',
}

export interface EditarOrcamentoContract {
  description: string;
  isClient: boolean;
  idClient?: string | null;
  isProfitMargin: boolean;
  idProfitMargin?: string;
  percentageExtraCost?: number;
  status: StutusBudgetEnum;
  fantasyName?: string;
  // Dados cadastrais (obrigatórios se !isClient)
  personType?: PersonTypeEnum | null; // obrigatório se !isClient
  corporateName?: string; // obrigatório se !isClient && personType === PJ
  cnpj?: string; // obrigatório se !isClient && personType === PJ
  cpf?: string; // obrigatório se !isClient && personType === PF
  fullName?: string; // obrigatório se !isClient && personType === PF
  email?: string;
  phone?: string; // obrigatório se !isClient
  dateValidation: Date;
  isDiscount: boolean;
  discountType?: DiscountTypeEnum;
  discountValue?: number;
  observation?: string | null;
  address: AddressContract;
  steps: StepByStepBudgetingContract[];
}

export interface AddressContract {
  zipCode: string;
  street: string;
  number: string;
  complement?: string;
  neighborhood: string;
  city: string;
  state: string;
}

